import React from "react";
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin"
import Prose from "../utility/prose";

const RentalCalendar = () => {
  return (
    <div className={`m-auto md:w-full mb-14 leading-none`}>
      <div className="iframe-4by3-wrapper iframe-calendar-wrapper">
        <iframe className="iframe-rounded iframe-calendar" src="https://outlook.office365.com/owa/calendar/2fad0ebee2e74267a0616b580599c60a@bridgestonemud.com/fbb9839093e142f0bd1909129c40ec137765106297045648741/calendar.html" style={{borderWidth:0}} frameborder="0" scrolling="yes"></iframe>
      </div>
    </div>
  )
}

export default RentalCalendar

